"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Constants = require("../../Constants");

var ContentHolder = (0, _styledComponents.default)('div').withConfig({
  displayName: "AvatarContentHolder__ContentHolder",
  componentId: "sc-1nm6qpt-0"
})(["align-items:center;border-radius:", ";box-sizing:border-box;color:", ";display:flex;font-size:initial;", " height:", ";overflow:hidden;position:relative;width:", ";"], function (props) {
  return _Constants.AVATAR_TYPES[props.type] === _Constants.AVATAR_TYPES.productId ? '3px' : '50%';
}, _colors.OLAF, function (props) {
  return props._isListReversed && "border: 2px solid " + _colors.OLAF + ";";
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + "px" : 'inherit';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + "px" : '100%';
});

var AvatarContentHolder = function AvatarContentHolder(props) {
  var href = props.href,
      children = props.children,
      size = props.size,
      type = props.type,
      _isListReversed = props._isListReversed;
  var avatarWidth = size === _Constants.AVATAR_SIZES.responsive ? '100%' : "$[size}";
  var avatarHeight = size === _Constants.AVATAR_SIZES.responsive ? '' : "$[size}";

  if (href) {
    return _react.default.createElement(_UIButton.default, {
      style: {
        width: avatarWidth,
        height: avatarHeight
      },
      use: "unstyled",
      href: href
    }, _react.default.createElement(ContentHolder, {
      type: type,
      _isListReversed: _isListReversed,
      size: size
    }, children));
  }

  return _react.default.createElement(ContentHolder, {
    type: type,
    _isListReversed: _isListReversed,
    size: size
  }, children);
};

AvatarContentHolder.propTypes = {
  children: _propTypes.default.node.isRequired,
  href: _propTypes.default.string,
  size: _propTypes.default.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  type: _propTypes.default.oneOf(Object.keys(_Constants.AVATAR_TYPES)),
  _isListReversed: _propTypes.default.bool
};
var _default = AvatarContentHolder;
exports.default = _default;
module.exports = exports.default;